import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Toast, ToastBody } from "reactstrap"
import { restMessage } from "../store"

function MsgToast() {
    const dispatch = useDispatch()
    const message = useSelector(state => state.message)

    useEffect(() => {
        const id = setTimeout(() => {
            dispatch(restMessage())
        }, 5000)

        return () => clearTimeout(id)
    }, [message])

    function getStatus() {
        if (message.status === 'success') {
            return <i className="bi bi-check-square-fill text-success me-2"></i>
        }

        if(message.status ==='info') {
            return <i className="bi bi-info-square-fill text-info me-2"></i>
        }

        if(message.status === 'error') {
            return <i className="bi bi-x-square-fill text-danger me-2"></i>
        }
    }

    return (
        <Toast id="msg-toast" isOpen={message.isVisible}>
            <ToastBody>
                {getStatus()}
                {message.text}
            </ToastBody>
        </Toast>
    )
}

export default MsgToast
